package io.horion.cv.pages.dashboard

import androidx.compose.runtime.*
import io.horion.cv.components.auth.RequireAuth
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaEllipsisVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaList
import com.varabyte.kobweb.silk.components.icons.fa.FaTableCells
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.api.datasource.common.Generate
import io.horion.cv.components.layouts.AppResponsiveLayout
import io.horion.cv.components.shared.CreateDocumentCard
import io.horion.cv.components.shared.DocumentCard
import io.horion.cv.di.koinGet
import io.horion.cv.models.ViewMode
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.styles.CandidaturesTextStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import io.horion.cv.viewModel.DashboardViewModel
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@OptIn(DelicateApi::class)
@Page("cv")
@Composable
fun CurriculumVitaePage() = RequireAuth {

    val ctx = rememberPageContext()

    val dashboardViewModel = koinGet<DashboardViewModel>()

    var viewMode by remember { mutableStateOf(ViewMode.GRID) }

    LaunchedEffect(Unit) {
        dashboardViewModel.loadCvHistory(refresh = true)
    }

    AppResponsiveLayout(activeLabel = "Curriculum vitae") {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .gap(24.px)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                SpanText(
                    text = "Curriculum vitae",
                    modifier = CandidaturesTextStyle.toModifier()
//                        .fontSize(if (isMobile) 20.px else 26.px)
                        .fontFamily(UBUNTU)
                        .fontWeight(FontWeight.SemiBold)
                        .color(Colors.DarkBlue)
                )

                ViewModeToggle(current = viewMode, onSelect = { viewMode = it })
            }

            when (viewMode) {
                ViewMode.GRID -> CvGridFull(
                    cvList = dashboardViewModel.cvList,
                    onNew = { ctx.router.navigateTo(Screen.CV.path) },
                    onEdit = { generate ->
                        ctx.router.navigateTo("${Screen.UpdateCv.path}?id=${generate.uuidDocument}&model=${generate.model ?: ""}")
                    },
                    onDelete = { id ->
                        if (kotlinx.browser.window.confirm("Voulez-vous vraiment supprimer ce CV ?")) {
                            dashboardViewModel.deleteCv(id)
                        }
                    },
                    onDownload = { url -> dashboardViewModel.downloadCv(url) },
                )
                ViewMode.LIST -> CvListFull(
                    cvList = dashboardViewModel.cvList,
                    onNew = { ctx.router.navigateTo(Screen.CV.path) },
                    onEdit = { generate ->
                        ctx.router.navigateTo("${Screen.UpdateCv.path}?id=${generate.uuidDocument}&model=${generate.model ?: ""}")
                    },
                    onDelete = { id ->
                        if (kotlinx.browser.window.confirm("Voulez-vous vraiment supprimer ce CV ?")) {
                            dashboardViewModel.deleteCv(id)
                        }
                    },
                    onDownload = { url -> dashboardViewModel.downloadCv(url) }
                )
            }
        }
    }
}

@Composable
fun ViewModeToggle(
    current: ViewMode,
    onSelect: (ViewMode) -> Unit
) {
    val iconFilter = if (current == ViewMode.GRID) {
        "invert(1)"
    } else {
        "none"
    }
    val iconListFilter = if (current == ViewMode.LIST) {
        "invert(1)"
    } else {
        "none"
    }
    Row(
        modifier = Modifier
            .border(1.px, LineStyle.Solid, Colors.lineBorder)
            .borderRadius(8.px)
            .overflow(Overflow.Hidden)
    ) {
        Box(
            modifier = Modifier
                .size(50.px)
                .backgroundColor(if (current == ViewMode.GRID) Colors.Blue else Colors.White)
                .cursor(Cursor.Pointer)
                .onClick { onSelect(ViewMode.GRID) },
            contentAlignment = Alignment.Center
        ) {
           /* Image(
                src = if (current == ViewMode.GRID) "/grid-white.svg" else "/grid-dark.svg",
                description = "Vue grille",
                modifier = Modifier.size(25.px)
            )*/
                FaTableCells(
                    modifier = Modifier.fontSize(25.px)
                        .styleModifier { property("filter", iconFilter)}
                )

        }

        Box(
            modifier = Modifier
                .width(1.px)
                .height(50.px)
                .backgroundColor(Colors.lineBorder)
        )

        Box(
            modifier = Modifier
                .size(50.px)
                .backgroundColor(if (current == ViewMode.LIST) Colors.Blue else Colors.White)
                .cursor(Cursor.Pointer)
                .onClick { onSelect(ViewMode.LIST) },
            contentAlignment = Alignment.Center
        ) {
            /*Image(
                src = if (current == ViewMode.LIST) "/list-white.svg" else "/list-dark.svg",
                description = "Vue liste",
                modifier = Modifier.size(25.px)
            )*/
            FaList(
                modifier = Modifier.fontSize(25.px)
                    .styleModifier { property("filter", iconListFilter)}
            )
        }
    }
}

@Composable
fun CvGridFull(
    cvList: List<Generate>,
    onNew: () -> Unit,
    onEdit: (Generate) -> Unit,
    onDelete: (String) -> Unit,
    onDownload: (String) -> Unit) {

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .gap(20.px)
            .styleModifier { property("flex-wrap", "wrap") },
        verticalAlignment = Alignment.Top
    ) {
        CreateDocumentCard(
            text = "Créer un nouveau CV",
            onClick = onNew
        )

        cvList.forEach { cv ->
            DocumentCard(
                title = cv.name ?: "CV sans titre",
                modifiedAgo = cv.date,
                previewSrc = cv.thumbnailUrl.ifBlank { null },
                onEdit = { onEdit(cv) },
                onDelete = { onDelete(cv.id) },
                onDownload = { onDownload(cv.url) }
            )
        }
    }
}

@Composable
fun CvListFull(
    cvList: List<Generate>,
    onNew: () -> Unit,
    onEdit: (Generate) -> Unit,
    onDelete: (String) -> Unit,
    onDownload: (String) -> Unit
) {
    Column(
        modifier = Modifier.fillMaxWidth().gap(0.px)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(56.px)
                .backgroundColor(Colors.White)
                .border(1.px, LineStyle.Solid, Colors.lineBorder)
                .borderRadius(8.px)
                .padding(leftRight = 20.px)
                .cursor(Cursor.Pointer)
                .onClick { onNew() }
                .gap(12.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                text = "+",
                modifier = Modifier
                    .fontSize(20.px)
                    .color(Colors.Graytext)
                    .fontWeight(FontWeight.Light)
            )
            SpanText(
                text = "Créer un nouveau CV",
                modifier = Modifier
                    .fontFamily(INTER)
                    .fontSize(15.px)
                    .color(Colors.Graytext)
            )
        }

        cvList.forEach { cv ->
            CvListRow(
                cv = cv,
                onEdit = { onEdit(cv) },
                onDelete = { onDelete(cv.id) },
                onDownload = { onDownload(cv.url) }
            )
        }
    }
}

@Composable
fun CvListRow(
    cv: Generate,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    onDownload: () -> Unit
) {
    var showMenu by remember { mutableStateOf(false) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(64.px)
            .backgroundColor(Colors.White)
            .border(1.px, LineStyle.Solid, Colors.lineBorder)
            .borderRadius(8.px)
            .margin(top = 8.px)
            .padding(leftRight = 20.px),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        Row(
            modifier = Modifier.gap(14.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                modifier = Modifier
                    .width(36.px).height(48.px)
                    .backgroundColor(Colors.PriceGray)
                    .borderRadius(4.px)
                    .border(1.px, LineStyle.Solid, Colors.lineBorder)
                    .overflow(Overflow.Hidden)
            ) {
                if (cv.thumbnailUrl.isNotBlank()) {
                    Image(src = cv.thumbnailUrl, description = cv.name ?: "CV", modifier = Modifier.fillMaxWidth())
                }
            }

            Column(modifier = Modifier.gap(4.px)) {
                SpanText(
                    text = cv.name ?: "CV sans titre",
                    modifier = Modifier.fontFamily(INTER).fontSize(14.px)
                        .fontWeight(FontWeight.Medium).color(Colors.Black)
                )
                SpanText(
                    text = cv.date,
                    modifier = Modifier.fontFamily(INTER).fontSize(12.px).color(Colors.Graytext)
                )
            }
        }

        Box(
            modifier = Modifier
                .size(40.px)
                .border(width = 1.px, LineStyle.Solid, Colors.lineBorder)
                .borderRadius(6.px)
                .cursor(Cursor.Pointer)
                .onClick { showMenu = !showMenu },
            contentAlignment = Alignment.Center
        ) {
            /*Image(
                src = "/dots-vertical1.svg",
                description = "Options",
                modifier = Modifier.size(25.px)
            )*/
            FaEllipsisVertical(
                modifier = Modifier.fontSize(20.px)
            )
        }

        if (showMenu) {
            io.horion.cv.components.shared.CardDropdownMenu(
                onEdit = { showMenu = false; onEdit() },
                onDelete = { showMenu = false; onDelete() },
                onDownload = { showMenu = false; onDownload() },
                onDismiss = { showMenu = false }
            )
        }
    }
}
